<template>
  <div>
    <!-- <img src="../assets/images/bg.png" alt="bg1" class="background-image2" /> -->
    <transition
      appear
      @before-enter="$animations.beforeEnterLogoArea"
      @enter="$animations.enterLogoArea"
    >
      <Logo></Logo>
    </transition>

    <transition
      appear
      @before-enter="$animations.beforeEnterAbove"
      @enter="$animations.enterAbove"
    >
      <div class="columns mb-0 is-centered">
        <div
          v-if="$root.selectedLanguage === `en`"
          class="column"
          style="text-align: center"
        >
          <img
            src="../assets/images/icons/RBDSecondheaderImagesEng/Group 289350.png"
            alt="contact-img"
            width="70%"
          />
        </div>
        <div
          v-if="$root.selectedLanguage === `si`"
          class="column"
          style="text-align: center"
        >
          <img
            src="../assets/images/icons/RBDSecondheaderImagesSin/Group 37572.png"
            alt="contact-img"
            width="70%"
          />
        </div>
      </div>
    </transition>
    <div class="card px-3" style="width: 80%; margin: auto">
      <transition
        appear
        @before-enter="$animations.beforeEnterAbove"
        @enter="$animations.enterAbove"
      >
        <div class="columns is-centered">
          <div class="column is-half ps-5" style="text-align: center">
            <img
              src="../assets/images/icons/Blue/Call.png"
              alt="contact-info-img"
              width="70"
              height="70"
            />
            <p
              :class="`text-center mx-3 ${
                $root.selectedLanguage === `ta`
                  ? `ta-he-line`
                  : $root.selectedLanguage === `si`
                  ? `si-he-line`
                  : `en-he-line`
              }`"
            >
              {{ $root.selectedLanguageData.contactInformation }}
            </p>
            <p
              :class="`${
                $root.selectedLanguage === `ta`
                  ? `ta-sub-line`
                  : $root.selectedLanguage === `si`
                  ? `si-sub-line`
                  : `en-sub-line`
              }`"
            >
              {{ $root.selectedLanguageData.weNeedaWaytoConnectWithYou }}
            </p>
            <p style="font-family: fira300">
              {{ $root.selectedLanguageData.dataEditByButton }}
            </p>
          </div>
        </div>
      </transition>
      <ValidationObserver v-slot="{ invalid }">
        <form @submit.prevent="">
          <div class="columns is-centered">
            <div class="column is-two-thirds pt-5 ps-5">
              <!--            <transition-group appear tag="div"-->
              <!--                        @before-enter="$animations.beforeEnterBelow"-->
              <!--                        @enter="$animations.enterBelow"-->
              <!--                        @leave="$animations.leaveBelow"-->
              <!--            >-->
              <div class="columns is-7 is-variable" :key="1">
                <div
                  class="column is-one-third"
                  v-if="$root.kycFieldVisibility.title"
                >
                  <label
                    :class="`${
                      $root.selectedLanguage === `ta`
                        ? `ta-label`
                        : $root.selectedLanguage === `si`
                        ? `si-label`
                        : ``
                    }`"
                    >{{ $root.selectedLanguageData.title
                    }}<span class="has-text-danger">*</span></label
                  >
                  <ValidationProvider
                    name="your name title"
                    :rules="{ required: true }"
                    v-slot="{ errors }"
                  >
                    <div>
                      <b-select
                        @focus="$inputFocused('title')"
                        @input="$inputChanged('title')"
                        @blur="$inputBlured('title')"
                        v-model="$root.formData.title"
                      >
                        <option value="Mr">
                          {{ $root.selectedLanguageData.mr }}
                        </option>
                        <option value="Mrs">
                          {{ $root.selectedLanguageData.mrs }}
                        </option>
                        <option value="Miss">
                          {{ $root.selectedLanguageData.miss }}
                        </option>
                        <option value="Dr">
                          {{ $root.selectedLanguageData.dr }}
                        </option>
                        <option value="Rev">
                          {{ $root.selectedLanguageData.rev }}
                        </option>
                      </b-select>
                    </div>
                    <span class="has-text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="column" v-if="$root.kycFieldVisibility.surname">
                  <label
                    :class="`${
                      $root.selectedLanguage === `ta`
                        ? `ta-label`
                        : $root.selectedLanguage === `si`
                        ? `si-label`
                        : ``
                    }`"
                    >{{ $root.selectedLanguageData.surname
                    }}<span class="has-text-danger">*</span></label
                  >
                  <div class="field">
                    <p class="control has-icons-right">
                      <ValidationProvider
                        name="Surname"
                        :rules="validateSurname()"
                        v-slot="{ errors }"
                      >
                        <b-input
                          type="text"
                          v-model="$root.formData.surname"
                          @focus="$inputFocused('surname')"
                          @input="
                            () => {
                              $inputChanged('surname');
                              calName();
                            }
                          "
                          @blur="$inputBlured('surname')"
                        />
                        <span class="icon is-small is-right">
                          <img
                            src="../assets/images/icons/Blue/Group 158.png"
                            alt="contact-name-img"
                            width="25"
                            height="25"
                          />
                        </span>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </p>
                  </div>
                </div>
              </div>

              <div v-if="$root.kycFieldVisibility.other_name" :key="2">
                <label
                  :class="`${
                    $root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                  }`"
                  >{{ $root.selectedLanguageData.otherName
                  }}<span class="has-text-danger">*</span></label
                >
                <b-field>
                  <p class="control has-icons-right">
                    <ValidationProvider
                      name="Other Name"
                      :rules="validateSurname()"
                      v-slot="{ errors }"
                    >
                      <b-input
                        type="text"
                        v-model="$root.formData.other_name"
                        @focus="$inputFocused('other_name')"
                        @input="
                          () => {
                            $inputChanged('other_name');
                            calName();
                          }
                        "
                        @blur="$inputBlured('other_name')"
                      />
                      <span class="icon is-small is-right mr-2">
                        <img
                          src="../assets/images/icons/Blue/Group 158.png"
                          alt="contact-name-img"
                          width="25"
                          height="25"
                        />
                      </span>
                      <span class="has-text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </p>
                </b-field>
              </div>

              <div
                class="mt-4"
                v-if="$root.kycFieldVisibility.contact_no"
                :key="3"
              >
                <label
                  :class="`${
                    $root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                  }`"
                  >{{ $root.selectedLanguageData.mobileNumber
                  }}<span class="has-text-danger">*</span></label
                >

                <div class="columns is-7 is-variable">
                  <div class="column is-one-third">
                    <div>
                      <section>
                        <b-field>
                          <p class="control has-icons-right">
                            <b-autocomplete
                              v-model="userCode"
                              maxlength="10"
                              icon-pack="fi"
                              :icon="iconString"
                              open-on-focus
                              :data="filteredDataArr"
                              @input="
                                () => {
                                  ++count;
                                  if (count === 2) {
                                    $root.formData.countryCode = ``;
                                    isCountryCodeTouched = true;
                                  }
                                }
                              "
                              @select="
                                (option) => {
                                  if (option) {
                                    $root.formData.countryCode = `+${
                                      option.split(`+`)[1]
                                    }`;
                                    $root.formData.mobileNumberCountrySelectionTemp =
                                      option;
                                  } else {
                                    $root.formData.countryCode = ``;
                                  }
                                  if ($root.formData.countryCode) {
                                    changeSelection();
                                    calPhoneNumber();
                                  }
                                }
                              "
                            >
                            </b-autocomplete>
                            <span class="icon is-small is-right mr-2">
                              <img
                                src="../assets/images/icons/Blue/Stroke.png"
                                alt="Stroke-img"
                                width="13"
                                height="13"
                              />
                            </span>
                            <span
                              class="has-text-danger"
                              v-if="
                                isCountryCodeTouched &&
                                !$root.formData.countryCode
                              "
                              >You have to select a valid country code</span
                            >
                          </p>
                        </b-field>
                        <!-- <span
                        v-if="
                          isCountryCodeTouched && !$root.formData.countryCode
                        "
                        class="has-text-danger"
                        >Country Code is required</span
                      > -->
                      </section>

                      <!-- <b-field>
                      <ValidationProvider
                        name="your country code"
                        :rules="{ required: true }"
                        v-slot="{ errors }"
                      >
                        <b-select
                          @input="
                            () => {
                              changeSelection();
                              calPhoneNumber();
                            }
                          "
                          v-model="$root.formData.countryCode"
                          icon-pack="fi"
                          :icon="iconString"
                          rounded
                        >
                          <option
                            v-for="country in $root.formData.countriesList"
                            :key="country.code"
                            :value="country.code"
                          >
                            {{ country.phone }} {{ country.code }}
                          </option>
                        </b-select>

                    </b-field> -->
                    </div>
                  </div>
                  <div class="column">
                    <b-field>
                      <p class="control has-icons-right">
                        <ValidationProvider
                          name="Phone Number"
                          :rules="{ required: true, onlyNumbers: true }"
                          v-slot="{ errors }"
                        >
                          <b-input
                            placeholder="771212122"
                            type="tel"
                            v-model="$root.formData.mobileNumber"
                            @focus="$inputFocused('contact_no')"
                            @input="
                              () => {
                                $inputChanged('contact_no');
                                calPhoneNumber();
                              }
                            "
                            @blur="$inputBlured('contact_no')"
                          />
                          <span class="icon is-small is-right mr-2">
                            <img
                              src="../assets/images/icons/Blue/Call.png"
                              alt="contact-name-img"
                              width="25"
                              height="25"
                            />
                          </span>
                          <span class="has-text-danger">{{ errors[0] }}</span>
                          <span
                            class="has-text-danger"
                            v-if="isMobileNumberStartsWithZero"
                            >LK phone numbers not allowed to start with 0</span
                          >
                        </ValidationProvider>
                      </p>
                    </b-field>
                  </div>
                </div>
              </div>

              <div class="mt-5" v-if="$root.kycFieldVisibility.email" :key="4">
                <label
                  :class="`${
                    $root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                  }`"
                  >{{ $root.selectedLanguageData.emailAddress
                  }}<span class="has-text-danger">*</span></label
                >
                <b-field>
                  <p class="control has-icons-right">
                    <ValidationProvider
                      :rules="{
                        email: true,
                        required: true,
                        lessOrEqualLength: 256,
                      }"
                      name="Email"
                      v-slot="{ errors }"
                    >
                      <b-input
                        type="email"
                        @focus="$inputFocused('email')"
                        @input="$inputChanged('email')"
                        @blur="$inputBlured('email')"
                        v-model="$root.formData.email"
                      />
                      <span class="icon is-small is-right mr-2">
                        <img
                          src="../assets/images/icons/Blue/Group 156.png"
                          alt="contact-name-img"
                          width="25"
                          height="25"
                        />
                      </span>
                      <span class="has-text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </p>
                </b-field>
              </div>

              <div class="columns mt-4 is-7 is-variable" :key="5">
                <div
                  class="column is-one-two"
                  v-if="$root.kycFieldVisibility.account_type"
                >
                  <label
                    :class="`${
                      $root.selectedLanguage === `ta`
                        ? `ta-label`
                        : $root.selectedLanguage === `si`
                        ? `si-label`
                        : ``
                    }`"
                    >{{ $root.selectedLanguageData.typeofAccount
                    }}<span class="has-text-danger">*</span></label
                  >
                  <b-field>
                    <ValidationProvider
                      :rules="{ required: true }"
                      v-slot="{ errors }"
                    >
                      <b-select
                        @focus="$inputFocused('account_type')"
                        @input="$inputChanged('account_type')"
                        @blur="$inputBlured('account_type')"
                        v-model="$root.formData.account_type"
                        expanded
                      >
                        <option value="Savings">
                          {{ $root.selectedLanguageData.savingAccount }}
                        </option>
                        <!--<option value="Personal Foreign Currency Account">-->
                        <!--{{ $root.selectedLanguageData.pfc }}-->
                        <!--</option>-->
                      </b-select>
                      <span class="has-text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-field>
                </div>
                <div
                  class="column is-one-two"
                  v-if="$root.kycFieldVisibility.currency_type"
                >
                  <div v-if="$root.formData.account_type === `Savings`">
                    <label
                      :class="`${
                        $root.selectedLanguage === `ta`
                          ? `ta-label`
                          : $root.selectedLanguage === `si`
                          ? `si-label`
                          : ``
                      }`"
                      >{{ $root.selectedLanguageData.currencyType }}
                      <span class="has-text-danger">*</span></label
                    >
                    <b-field>
                      <b-input
                        type="text"
                        disabled
                        v-model="$root.formData.srilankanCurrencyType"
                      />
                    </b-field>
                  </div>
                  <div
                    v-if="
                      $root.formData.account_type ===
                      `Personal Foreign Currency Account`
                    "
                  >
                    <label
                      :class="`${
                        $root.selectedLanguage === `ta`
                          ? `ta-label`
                          : $root.selectedLanguage === `si`
                          ? `si-label`
                          : ``
                      }`"
                      >{{ $root.selectedLanguageData.currencyType }}
                      <span class="has-text-danger">*</span></label
                    >
                    <b-field>
                      <ValidationProvider rules="required" v-slot="{ errors }">
                        <b-select
                          v-model="$root.formData.forignCurrencyType"
                          expanded
                        >
                          <!--                        <option>US DOLLARS</option>-->
                          <!--<option>EURO</option>-->
                          <!--<option>STERLING POUNDS</option>-->
                          <!--<option>JAPANESE YEN</option>-->
                          <!--<option>AUSTRALIAN DOLLARS</option>-->
                          <!--<option>SWISS FRANC</option>-->
                          <!--<option>SINGAPORE DOLLARS</option>-->
                          <!--<option>CANADIAN DOLLARS</option>-->
                          <!-- <option>ARAB EMIRATES DIRHAMS</option>-->
                          <option
                            v-for="currency in $root.formData.currencies"
                            :key="currency.currency_code"
                            :value="
                              currency.currency_code +
                              '-' +
                              currency.currency_name
                            "
                          >
                            {{ currency.currency_name }}
                          </option>
                        </b-select>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-field>
                  </div>
                </div>
              </div>
              <!-- <div>
                <label
                  >{{ $root.selectedLanguageData.registeringBranch }}
                  <span class="has-text-danger">*</span></label
                >
                <b-field>
                  <p class="control has-icons-right">
                    <ValidationProvider
                      name="branch name"
                      rules="alphaSpaces|required"
                      v-slot="{ errors }"
                    >
                      <b-input
                        rounded
                        type="text"
                        disabled
                        v-model="$root.formData.branch"
                      />
                      <span class="icon is-small is-right mr-2">
                        <img
                          src="../assets/images/icons/Yellow/Location.png"
                          alt="contact-name-img"
                          width="25"
                          height="25"
                        />
                      </span>
                      <span class="has-text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </p>
                </b-field>
              </div> -->
              <div
                class="mt-4"
                v-if="$root.kycFieldVisibility.facility_internet_banking"
                :key="6"
              >
                <label
                  :class="`${
                    $root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                  }`"
                  >{{ $root.selectedLanguageData.internetBankingFacility
                  }}<span class="has-text-danger">*</span></label
                >
                <ValidationProvider
                  :rules="{ required: true }"
                  v-slot="{ errors }"
                >
                  <div class="columns">
                    <div class="column is-one-two">
                      <b-field>
                        <b-radio
                          style="font-family: OpenSans-Regular"
                          native-value="Yes"
                          @focus="$inputFocused('facility_internet_banking')"
                          @input="$inputChanged('facility_internet_banking')"
                          @blur="$inputBlured('facility_internet_banking')"
                          v-model="$root.formData.facility_internet_banking"
                          @click.native="isModalActive = true"
                        >
                          {{ $root.selectedLanguageData.yes }}
                        </b-radio>
                      </b-field>
                    </div>

                    <div class="column is-one-two">
                      <b-field>
                        <b-radio
                          style="font-family: OpenSans-Regular"
                          native-value="No"
                          @focus="$inputFocused('facility_internet_banking')"
                          @input="$inputChanged('facility_internet_banking')"
                          @blur="$inputBlured('facility_internet_banking')"
                          v-model="$root.formData.facility_internet_banking"
                        >
                          {{ $root.selectedLanguageData.no }}
                        </b-radio>
                      </b-field>
                    </div>
                  </div>
                  <span class="has-text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <!--            </transition-group>-->

              <b-modal v-model="isModalActive" :width="1150" scroll="keep">
                <div class="card">
                  <header class="modal-card-head">
                    <div>
                      <p class="modal-card-title">
                        {{
                          $root.selectedLanguageData
                            .internetBankingFacility_title
                        }}
                      </p>
                    </div>
                    <div class="modal-close-button">
                      <button
                        class="delete"
                        aria-label="close"
                        @click="
                          () => {
                            isModalActive = false;
                            showContent = false;
                          }
                        "
                      ></button>
                    </div>
                  </header>
                  <div class="card-content">
                    <p class="card-content-text">
                      {{
                        $root.selectedLanguageData
                          .internetBankingFacility_content_one
                      }}
                      <br />
                      <br />
                    </p>
                    <p class="card-content-text has-text-weight-semibold">
                      {{ $root.selectedLanguageData.transactions_instructions }}
                    </p>
                    <p class="card-content-text">
                      {{
                        $root.selectedLanguageData
                          .internetBankingFacility_content_two
                      }}
                      <br />
                      <br />
                    </p>
                    <p class="card-content-text">
                      {{
                        $root.selectedLanguageData
                          .internetBankingFacility_content_three
                      }}
                      <br />
                      <br />
                    </p>
                    <p class="card-content-text">
                      {{
                        $root.selectedLanguageData
                          .internetBankingFacility_content_four
                      }}
                      <br />
                      <br />
                    </p>
                    <div>
                      <div v-show="!showContent">
                        <p>
                          {{
                            $root.selectedLanguageData
                              .internetBankingFacility_content_five
                          }}
                          <span @click="showContent = true" class="showcontant">
                            {{ $root.selectedLanguageData.seeMore }}
                          </span>
                        </p>
                      </div>
                      <div v-show="showContent">
                        <p class="card-content-text">
                          {{
                            $root.selectedLanguageData
                              .internetBankingFacility_content_five
                          }}
                          <br />
                          <br />
                        </p>
                        <p class="card-content-text">
                          {{
                            $root.selectedLanguageData
                              .internetBankingFacility_content_six
                          }}
                          <br />
                          <br />
                        </p>
                        <p class="card-content-text">
                          {{
                            $root.selectedLanguageData
                              .internetBankingFacility_content_seven
                          }}
                          <br />
                          <br />
                          {{
                            $root.selectedLanguageData
                              .internetBankingFacility_content_seven_part
                          }}
                          <br />
                          <br />
                        </p>
                        <p class="card-content-text">
                          {{
                            $root.selectedLanguageData
                              .internetBankingFacility_content_eight
                          }}
                          <br />
                          <br />
                        </p>
                        <p class="card-content-text">
                          {{
                            $root.selectedLanguageData
                              .internetBankingFacility_content_nine
                          }}
                          <br />
                          <br />
                        </p>
                        <p class="card-content-text">
                          {{
                            $root.selectedLanguageData
                              .internetBankingFacility_content_ten
                          }}
                          <br />
                          <br />
                        </p>
                        <p class="card-content-text">
                          {{
                            $root.selectedLanguageData
                              .internetBankingFacility_content_eleven
                          }}
                          <br />
                          <br />
                        </p>
                        <p class="card-content-text">
                          {{
                            $root.selectedLanguageData
                              .internetBankingFacility_content_twelve
                          }}
                          <br />
                          <br />
                        </p>
                        <p class="card-content-text">
                          {{
                            $root.selectedLanguageData
                              .internetBankingFacility_content_thirteen
                          }}
                          <br />
                          <br />
                        </p>
                        <div>
                          <p class="card-content-text has-text-weight-semibold">
                            {{
                              $root.selectedLanguageData
                                .transactions_instructions
                            }}

                            <br />
                          </p>
                          <p class="card-content-text">
                            {{
                              $root.selectedLanguageData
                                .internetBankingFacility_content_two_one
                            }}
                            <br />
                            <br />
                          </p>
                          <p class="card-content-text">
                            {{
                              $root.selectedLanguageData
                                .internetBankingFacility_content_two_two
                            }}
                            <br />
                            <br />
                          </p>
                          <p class="card-content-text">
                            {{
                              $root.selectedLanguageData
                                .internetBankingFacility_content_two_three
                            }}
                            <br />
                            <br />
                          </p>
                          <p class="card-content-text">
                            {{
                              $root.selectedLanguageData
                                .internetBankingFacility_content_two_four
                            }}
                            <br />
                            <br />
                          </p>
                          <p class="card-content-text">
                            {{
                              $root.selectedLanguageData
                                .internetBankingFacility_content_two_five
                            }}
                            <br />
                            <br />
                          </p>
                          <p class="card-content-text">
                            {{
                              $root.selectedLanguageData
                                .internetBankingFacility_content_two_six
                            }}
                            <br />
                            <br />
                          </p>
                        </div>
                        <div>
                          <p class="card-content-text has-text-weight-semibold">
                            {{
                              $root.selectedLanguageData
                                .copyright_proprietary_right
                            }}
                            <br />
                          </p>
                          <p class="card-content-text">
                            {{
                              $root.selectedLanguageData
                                .copyright_proprietary_right_one
                            }}
                            <br />
                            <br />
                          </p>
                          <p class="card-content-text">
                            {{
                              $root.selectedLanguageData
                                .copyright_proprietary_right_two
                            }}
                            <br />
                            <br />
                          </p>
                        </div>
                        <div>
                          <p class="card-content-text has-text-weight-semibold">
                            {{ $root.selectedLanguageData.confidentiality }}

                            <br />
                          </p>
                          <p class="card-content-text">
                            {{ $root.selectedLanguageData.confidentiality_one }}
                            <br />
                            <br />
                          </p>
                          <p class="card-content-text">
                            {{ $root.selectedLanguageData.confidentiality_two }}
                            <br />
                            <br />
                          </p>
                        </div>
                        <div>
                          <p class="card-content-text has-text-weight-semibold">
                            {{ $root.selectedLanguageData.charges_payments }}

                            <br />
                          </p>
                          <p class="card-content-text">
                            {{
                              $root.selectedLanguageData.charges_payments_one
                            }}
                            <br />
                            <br />
                          </p>
                          <p class="card-content-text">
                            {{
                              $root.selectedLanguageData.charges_payments_two
                            }}
                            <br />
                            <br />
                          </p>
                        </div>

                        <div>
                          <p class="card-content-text has-text-weight-semibold">
                            {{ $root.selectedLanguageData.liabilities_delay }}

                            <br />
                          </p>
                          <p class="card-content-text">
                            {{
                              $root.selectedLanguageData.liabilities_delay_one
                            }}
                            <br />
                            <br />
                          </p>
                          <p class="card-content-text">
                            {{
                              $root.selectedLanguageData.liabilities_delay_two
                            }}
                            <br />
                            <br />
                          </p>
                          <p class="card-content-text">
                            {{
                              $root.selectedLanguageData.liabilities_delay_three
                            }}
                            <br />
                            <br />
                          </p>
                        </div>
                        <div>
                          <p class="card-content-text has-text-weight-semibold">
                            {{
                              $root.selectedLanguageData
                                .revision_of_terms_and_conditions
                            }}

                            <br />
                          </p>
                          <p class="card-content-text">
                            {{
                              $root.selectedLanguageData
                                .revision_of_terms_and_conditions_one
                            }}
                            <br />
                            <br />
                          </p>
                          <p class="card-content-text">
                            {{
                              $root.selectedLanguageData
                                .revision_of_terms_and_conditions_two
                            }}
                            <br />
                            <br />
                          </p>
                          <p class="card-content-text">
                            {{
                              $root.selectedLanguageData
                                .revision_of_terms_and_conditions_three
                            }}
                            <br />
                            <br />
                          </p>
                          <p class="card-content-text">
                            {{
                              $root.selectedLanguageData
                                .revision_of_terms_and_conditions_four
                            }}
                            <br />
                            <br />
                          </p>
                          <p class="card-content-text">
                            {{
                              $root.selectedLanguageData
                                .revision_of_terms_and_conditions_five
                            }}
                            <br />
                            <br />
                          </p>
                          <p class="card-content-text">
                            {{
                              $root.selectedLanguageData
                                .revision_of_terms_and_conditions_six
                            }}
                            <br />
                            <br />
                          </p>
                        </div>
                        <div>
                          <p class="card-content-text has-text-weight-semibold">
                            {{ $root.selectedLanguageData.indeminity }}

                            <br />
                          </p>
                          <p class="card-content-text">
                            {{ $root.selectedLanguageData.indeminity_one }}
                            <br />
                            <br />
                          </p>
                        </div>
                        <div>
                          <p class="card-content-text has-text-weight-semibold">
                            {{ $root.selectedLanguageData.governing_law }}

                            <br />
                          </p>
                          <p class="card-content-text">
                            {{ $root.selectedLanguageData.governing_law_one }}
                            <br />
                            <br />
                          </p>
                          <p class="card-content-text">
                            {{ $root.selectedLanguageData.governing_law_two }}
                            <span
                              @click="showContent = false"
                              class="showcontant"
                              >{{ $root.selectedLanguageData.seeLess }}</span
                            >
                            <br />
                            <br />
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="pb-4 is-flex is-justify-content-flex-end">
                    <b-button
                      class="reject-button"
                      @click="
                        () => {
                          modalReject();
                          showContent = false;
                        }
                      "
                    >
                      {{ $root.selectedLanguageData.reject }}
                    </b-button>
                    <b-button
                      class="is-primary mr-4 agree-button"
                      @click="
                        () => {
                          isModalActive = false;
                          showContent = false;
                        }
                      "
                    >
                      {{ $root.selectedLanguageData.agree }}
                    </b-button>
                  </div>
                </div>
              </b-modal>
              <transition
                appear
                @before-enter="$animations.beforeEnterBelow"
                @enter="$animations.enterBelow"
                @leave="$animations.leaveBelow"
              >
                <div
                  class="mt-4"
                  v-if="$root.kycFieldVisibility.facility_debit_card"
                >
                  <label
                    :class="`${
                      $root.selectedLanguage === `ta`
                        ? `ta-label`
                        : $root.selectedLanguage === `si`
                        ? `si-label`
                        : ``
                    }`"
                    >{{ $root.selectedLanguageData.debitCardFacility
                    }}<span class="has-text-danger">*</span></label
                  >
                  <ValidationProvider
                    name="This field"
                    :rules="{ required: true }"
                    v-slot="{ errors }"
                  >
                    <div class="columns">
                      <div class="column is-one-two">
                        <b-field>
                          <b-radio
                            style="font-family: OpenSans-Regular"
                            native-value="Yes"
                            @focus="$inputFocused('facility_debit_card')"
                            @input="$inputChanged('facility_debit_card')"
                            @blur="$inputBlured('facility_debit_card')"
                            v-model="$root.formData.facility_debit_card"
                            @click.native="isDebitModalActive = true"
                          >
                            {{ $root.selectedLanguageData.yes }}
                          </b-radio>
                        </b-field>
                      </div>

                      <div class="column is-one-two">
                        <b-field>
                          <b-radio
                            style="font-family: OpenSans-Regular"
                            native-value="No"
                            @focus="$inputFocused('facility_debit_card')"
                            @input="$inputChanged('facility_debit_card')"
                            @blur="$inputBlured('facility_debit_card')"
                            v-model="$root.formData.facility_debit_card"
                          >
                            {{ $root.selectedLanguageData.no }}
                          </b-radio>
                        </b-field>
                      </div>
                    </div>
                    <span class="has-text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </transition>
              <!-- modal box_2 -->
              <b-modal v-model="isDebitModalActive" :width="850" scroll="keep">
                <div class="card">
                  <header class="modal-card-head">
                    <div>
                      <p class="modal-card-title" style="font-family: OpenSans-Bold">
                        {{ $root.selectedLanguageData.terms_conditions }}
                      </p>
                    </div>
                    <div class="modal-close-button">
                      <button
                        class="delete"
                        aria-label="close"
                        @click="isDebitModalActive = false"
                      ></button>
                    </div>
                  </header>
                  <div class="card-content">
                    <p class="card-content-text">
                      {{
                        $root.selectedLanguageData.debitCardFacility_content_one
                      }}
                    </p>
                    <br />

                    <p class="card-content-text">
                      {{
                        $root.selectedLanguageData.debitCardFacility_content_two
                      }}
                    </p>
                    <br />

                    <p class="card-content-text">
                      {{
                        $root.selectedLanguageData
                          .debitCardFacility_content_three
                      }}
                    </p>
                    <br />
                    <div class="is-flex is-justify-content-flex-end">
                      <b-button
                        class="reject-button"
                        @click="debitModalReject()"
                      >
                        {{ $root.selectedLanguageData.reject }}
                      </b-button>
                      <b-button
                        class="is-primary mr-4 agree-button"
                        @click="isDebitModalActive = false"
                      >
                        {{ $root.selectedLanguageData.agree }}
                      </b-button>
                    </div>
                  </div>
                </div>
              </b-modal>
              <transition
                appear
                @before-enter="$animations.beforeEnterBelow"
                @enter="$animations.enterBelow"
                @leave="$animations.leaveBelow"
              >
                <div
                  class="mt-4"
                  v-if="$root.formData.facility_debit_card === `Yes`"
                >
                  <div v-if="$root.kycFieldVisibility.facility_debit_card_type">
                    <label
                      :class="`${
                        $root.selectedLanguage === `ta`
                          ? `ta-label`
                          : $root.selectedLanguage === `si`
                          ? `si-label`
                          : ``
                      }`"
                      >{{ $root.selectedLanguageData.selectTheCardType
                      }}<span class="has-text-danger">*</span></label
                    >
                    <div>
                      <ValidationProvider
                        name="This field"
                        :rules="{ required: true }"
                        v-slot="{ errors }"
                      >
                        <b-field>
                          <b-radio
                            style="font-family: OpenSans-Regular"
                            native-value="Visa Card"
                            @focus="$inputFocused('facility_debit_card_type')"
                            @input="$inputChanged('facility_debit_card_type')"
                            @blur="$inputBlured('facility_debit_card_type')"
                            v-model="$root.formData.facility_debit_card_type"
                            ><span
                              ><img
                                src="@/assets/images/icons/CardImages/Visa.webp"
                                alt="visa-img"
                                width="50px"
                                height="50px" /></span
                            >{{ $root.selectedLanguageData.visaCard }}
                          </b-radio>
                        </b-field>

                        <b-field>
                          <b-radio
                            style="font-family: OpenSans-Regular"
                            native-value="Mastercard"
                            @focus="$inputFocused('facility_debit_card_type')"
                            @input="$inputChanged('facility_debit_card_type')"
                            @blur="$inputBlured('facility_debit_card_type')"
                            v-model="$root.formData.facility_debit_card_type"
                            ><span
                              ><img
                                src="@/assets/images/icons/CardImages/Visa.webp"
                                alt="mastercard-img"
                                width="50px"
                            /></span>
                            {{ $root.selectedLanguageData.masterCard }}
                          </b-radio>
                        </b-field>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div
                    class="mt-4"
                    v-if="
                      $root.kycFieldVisibility.facility_debit_card_customer_name
                    "
                  >
                    <label
                      :class="`${
                        $root.selectedLanguage === `ta`
                          ? `ta-label`
                          : $root.selectedLanguage === `si`
                          ? `si-label`
                          : ``
                      }`"
                      >{{
                        $root.selectedLanguageData
                          .nameThatShouldAppearOnTheCard
                      }}<span class="has-text-danger"> *</span></label
                    >
                    <b-field>
                      <p class="control has-icons-right">
                        <ValidationProvider
                          name="name"
                          :rules="validateCardname()"
                          v-slot="{ errors }"
                        >
                          <b-input
                            type="text"
                            v-model="
                              $root.formData.facility_debit_card_customer_name
                            "
                            @focus="
                              $inputFocused('facility_debit_card_customer_name')
                            "
                            @input="
                              () => {
                                $inputChanged(
                                  'facility_debit_card_customer_name'
                                );
                                nameOnCard();
                              }
                            "
                            @blur="
                              $inputBlured('facility_debit_card_customer_name')
                            "
                          />
                          <span class="icon is-small is-right mr-2">
                            <img
                              src="../assets/images/icons/Blue/Group 158.png"
                              alt="contact-name-img"
                              width="25"
                              height="25"
                            />
                          </span>
                          <span class="has-text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </p>
                    </b-field>
                  </div>
                </div>
              </transition>
            </div>
          </div>

          <transition
            appear
            @before-enter="$animations.beforeEnterBelow"
            @enter="$animations.enterBelow"
            @leave="$animations.leaveBelow"
          >
            <div class="columns">
              <div
                class="column is-6 is-offset-4 is-flex is-flex-direction-row-reverse"
              >
                <b-button
                  :class="`is-primary  ${
                    $root.selectedLanguage === `ta`
                      ? `continue-button-ta`
                      : $root.selectedLanguage === `si`
                      ? `continue-button-si`
                      : `continue-button-en`
                  }`"
                  :disabled="
                    invalid ||
                    ($root.kycFieldVisibility.contact_no
                      ? !$root.formData.countryCode
                      : false) ||
                    isMobileNumberStartsWithZero
                  "
                  @click="goToOTPPage"
                >
                  <!--@click="$router.push('otp')"-->
                  <!-- :disabled="invalid || userCode !== $root.formData.countryCode" -->

                  {{ $root.selectedLanguageData.continue }}
                </b-button>
                <b-button
                  :class="` ${
                    $root.selectedLanguage === `ta`
                      ? `back-button-ta`
                      : $root.selectedLanguage === `si`
                      ? `back-button-si`
                      : `back-button-en`
                  }`"
                  @click="$router.go(-1)"
                  >{{ $root.selectedLanguageData.back }}
                </b-button>
              </div>
            </div>
          </transition>
        </form>
      </ValidationObserver>
    </div>
    <GetHelp v-if="false"></GetHelp>
  </div>
</template>

<script>
import "../validate.js";
import GetHelp from "./GetHelp.vue";
import Logo from "./NsbKycLogo.vue";

export default {
  components: {
    GetHelp,
    Logo,
  },
  data() {
    return {
      showContent: false,
      isModalActive: false,
      isDebitModalActive: false,
      country: "",
      iconString: "",
      count: 0,
      country_code: "",
      regex: {
        srilankan_mobile: /^([7][0||1||2||4||5||6||7||8||][0-9]{7})$/,
        indian_mobile: /^[6-9]\d{9}$/,
      },
      userCode: "",
      countryCodeArray: [],
      isCountryCodeTouched: false,
      isMobileNumberStartsWithZero: false,
    };
  },
  methods: {
    mobileNumValidate: function () {
      const comp = this;
      let obj = {
        required: true,
      };

      if (comp.$root.formData.countryCode === "+94") {
        obj.regex = comp.regex.srilankan_mobile;
      } else if (comp.$root.formData.countryCode === "+91") {
        obj.regex = comp.regex.indian_mobile;
      }
      return obj;
    },

    calName() {
      this.$root.formData.name_with_init = "";
      this.$root.formData.full_name = "";

      if (this.$root.formData.surname.trim() != "") {
        const surnameArray = this.$root.formData.other_name.split(" ");
        for (const word of surnameArray) {
          this.$root.formData.name_with_init += `${word
            .trim()
            .charAt(0)
            .toUpperCase()} `;
        }
        this.$root.formData.name_with_init += this.$root.formData.surname;
        this.$root.formData.full_name =
          this.$root.formData.other_name.trim() +
          " " +
          this.$root.formData.surname.trim();
        this.$root.formData.facility_debit_card_customer_name =
          this.$root.formData.name_with_init.toUpperCase();
      }

      // Use following console logs to test the name generation process
      // console.log("==============================================")
      // console.log("Name should appear on the card :"+ this.$root.formData.facility_debit_card_customer_name )
      // console.log("Name with initials :"+ this.$root.formData.name_with_init )
      // console.log("Full name :"+ this.$root.formData.full_name )
    },
    nameOnCard() {
      this.$root.formData.facility_debit_card_customer_name =
        this.$root.formData.facility_debit_card_customer_name.toUpperCase();
    },
    changeSelection() {
      const countryCodeTemp = this.$root.formData.countriesList.find(
        (countryObject) =>
          // countryObject.phone === this.$root.formData.countryCode
          countryObject.code ===
          this.$root.formData.mobileNumberCountrySelectionTemp.split(" ")[0]
      );
      this.$root.formData.country_short_name = `${countryCodeTemp.code} ${countryCodeTemp.phone}`;
      this.iconString = `fi fi-${countryCodeTemp.code.toLowerCase()}`;
    },

    validateFullName: function () {
      const obj = {
        required: true,
        alphaSpaces: true,
        notStartsWith: " ",
        notEndsWith: " ",
        notConsecutive: "  ",
        includes: " ",
      };
      return obj;
    },
    validateSurname: function () {
      const obj = {
        required: true,
        alphaSpaces: true,
        notStartsWith: " ",
        notEndsWith: " ",
        notConsecutive: "  ",
      };
      return obj;
    },
    validateCardname: function () {
      const obj = {
        required: true,
        alphaSpaces: true,
        lessOrEqualLength: 30,
        notStartsWith: " ",
        notEndsWith: " ",
        notConsecutive: "  ",
      };
      return obj;
    },
    modalReject() {
      this.$root.formData.facility_internet_banking = `No`;
      this.isModalActive = false;
    },
    debitModalReject() {
      this.$root.formData.facility_debit_card = `No`;
      this.isDebitModalActive = false;
    },
    getCurrencyTypes() {
      try {
        window.element = this;
        let kyc_token =
          this.$root.formData.kyc_token +
          "." +
          this.$root.formData.color_code4 +
          "." +
          this.$root.formData.color_code12;
        this.$http
          .post(
            this.$baseURL + "/getCurrencyType",
            {},
            {
              headers: { "X-token": kyc_token },
            }
          )
          .then((response) => {
            if (response.data.success) {
              console.log(response.data.data.currencies);
              this.$root.formData.currencies = response.data.data.currencies;
            } else {
              console.log(response.data);
              this.$buefy.toast.open({
                message: "Failed to fetch currency types",
                type: "is-danger",
              });
            }
          });
      } catch (e) {
        this.$buefy.toast.open({
          message: "Failed to fetch currency types",
          type: "is-danger",
        });
      }
    },

    goToOTPPage() {
      if (this.$root.formData.account_type == "Savings") {
        this.$root.formData.currency_type = "SRI LANKAN RUPEE";
        this.$root.formData.currency_type_code =
          this.$root.formData.srilankanCurrencyType;
      } else if (
        this.$root.formData.account_type == "Personal Foreign Currency Account"
      ) {
        console.log(
          "Raw currency value : " + this.$root.formData.forignCurrencyType
        );
        let selectedCurrencySplit =
          this.$root.formData.forignCurrencyType.split("-");

        this.$root.formData.currency_type_code = selectedCurrencySplit[0];
        this.$root.formData.currency_type = selectedCurrencySplit[1];
      }

      console.log(this.$root.formData.currency_type);
      console.log(this.$root.formData.currency_type_code);

      this.$router.push("otp");
    },

    updateLastStep() {
      try {
        window.element = this;
        let kyc_token =
          this.$root.formData.kyc_token +
          "." +
          this.$root.formData.color_code4 +
          "." +
          this.$root.formData.color_code12;
        this.$http
          .post(
            this.$baseURL + "/kycForm/updateLastStep",
            {
              last_step: 3,
            },
            {
              headers: { "X-token": kyc_token },
            }
          )
          .then((response) => {
            if (response.data.success) {
              console.log(response.data);
            } else {
              console.log(response.data);
            }
          })
          .catch((response) => {
            this.$buefy.toast.open({
              message: response.message,
              type: "is-danger",
            });
          });
      } catch (e) {
        this.$buefy.toast.open({
          message: "Failed to update last step",
          type: "is-danger",
        });
      }
    },

    calPhoneNumber() {
      if (this.$root.formData.countryCode === "+94") {
        console.log("LK Mobile number ---------------");
        const tempMobileNumber = this.$root.formData.mobileNumber.trim();
        if (tempMobileNumber[0] === "0") {
          this.isMobileNumberStartsWithZero = true;
        } else {
          this.isMobileNumberStartsWithZero = false;
        }
      } else {
        this.isMobileNumberStartsWithZero = false;
      }
      this.$root.formData.contact_no = `${this.$root.formData.countryCode}${this.$root.formData.mobileNumber}`;
      console.log(
        "Contact Number Formatted : " + this.$root.formData.contact_no
      );
    },
  },
  computed: {
    filteredDataArr() {
      const isExactMatch = this.countryCodeArray.some(
        (option) => option.toLowerCase() === this.userCode.toLowerCase()
      );
      if (isExactMatch) {
        return this.countryCodeArray;
      }
      return this.countryCodeArray.filter((option) => {
        return option.toLowerCase().indexOf(this.userCode.toLowerCase()) >= 0;
      });
    },
  },

  mounted: function () {
    // this.getCurrencyTypes();
    this.updateLastStep();
    for (const country of this.$root.formData.countriesList) {
      this.countryCodeArray.push(`${country.code} ${country.phone}`);
    }
    if (!this.$root.formData.countryCode) {
      this.$root.formData.countryCode = "+94";
      this.$root.formData.mobileNumberCountrySelectionTemp = "LK";
    }
    const tempCountryCodeName = this.$root.formData.countriesList.find(
      // (country) => country.phone === this.$root.formData.countryCode
      (country) =>
        country.code ===
        this.$root.formData.mobileNumberCountrySelectionTemp.split(" ")[0]
    );
    this.userCode = this.countryCodeArray.find(
      (hello) =>
        hello ===
        `${tempCountryCodeName.code} ${this.$root.formData.countryCode}`
    );

    this.changeSelection();
  },
};
</script>
<style>
.card-content-text {
  text-align: justify;
  font-size: 1rem;
  font-family: "OpenSans-Regular";
}
</style>
